import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import ErrorMessage from "../../../components/comman/ErrorMessage";

const CreateDebitNoteModal = ({
  modal,
  toggle,
  invoiceDetail,
  GetInvoiceDetail,
  editData,
}) => {
  // console.log("invoiceDetail>>>>>.", invoiceDetail);
  // console.log("editData>>>>>.", editData);

  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (!editData) {
      reset({
        transactionDate: moment().format("YYYY-MM-DD"),
        siteId: invoiceDetail?.workorder?.siteId,
        invoiceId: invoiceDetail?.id,
        amount: invoiceDetail?.amount,
        // gst: "",
        // taxableAmount: "",
        remark: "",
      });
    } else {
      reset({
        transactionDate: editData.transactionDate
          ? moment(editData.transactionDate).format("YYYY-MM-DD")
          : "",
        siteId: invoiceDetail?.workorder?.siteId,
        invoiceId: invoiceDetail?.id,
        amount: editData?.amount,
        // gst: "",
        // taxableAmount: "",
        remark: editData?.remark,
      });
    }
  }, [editData, reset]);


  const closeHandler = () => {
    toggle();
    reset();
  };

  let Balance =
    invoiceDetail?.grossAmount || invoiceDetail?.receivedAmount
      ? +invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount
      : 0;

  const onSubmit = (data) => {
    // console.log("Data>>>>>>>>>>>>>>>.", data);
    const submitData = {
      ...(editData ? {} : { invoiceId: invoiceDetail?.id }),
      customerId: invoiceDetail?.workorder?.site?.customerId,
      transactionDate: data?.transactionDate,
      siteId: invoiceDetail?.workorder?.siteId,
      amount: data?.amount,
      // gst: data?.gst,
      // taxableAmount: data?.taxableAmount,
      type: "debitNote",
      remark: data?.remark
    };
    // console.log("submitData>>>>.", submitData);

    const options = {
      method: "POST",
      data: submitData,
    };
    let API = editData
      ? apiUrl?.update_transaction + `?transactionId=${editData?.id}`
      : apiUrl?.create_transaction;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        GetInvoiceDetail();
        closeHandler();
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <Modal
      className="modal-dialog modal-xl modal-dialog-centered debit-note-modal"
      isOpen={modal}
      toggle={closeHandler}
      centered
    >
      {/* Modal Header */}
      <ModalHeader tag="h3" toggle={closeHandler}>
        {editData ? "Update" : "Create"} Debit Note
      </ModalHeader>

      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody className="p-4">
          <div className="table-responsive mb-3">
            <table className="table">
              <tbody>
                <tr>
                  <td className="fs-3">Invoice No.</td>
                  <td className="fs-3">
                    {invoiceDetail?.invoiceNumber || "--"}
                  </td>
                </tr>
                <tr>
                  <td className="fs-3">Total Bill</td>
                  <td className="fs-3">{invoiceDetail?.grossAmount || "--"}</td>
                </tr>
                <tr>
                  <td className="fs-3">Received Amount</td>
                  <td className="fs-3">{invoiceDetail?.receivedAmount || 0}</td>
                </tr>
                <tr>
                  <td className="fs-3">Balance</td>
                  <td
                    className={
                      invoiceDetail?.grossAmount > invoiceDetail?.receivedAmount
                        ? "text-danger fw-bold fs-3"
                        : "text-success fw-bold fs-3"
                    }
                  >
                    {Balance || 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label className="form-label" htmlFor="bDate">
                  Date
                </label>
                <Controller
                  name="transactionDate"
                  control={control}
                  rules={{
                    required: "This field is required",
                    validate: (value) => {
                      const invoiceDate = invoiceDetail?.createdAt ? moment(invoiceDetail?.createdAt).startOf('day') : null;
                      const today = moment().startOf('day');
                      const checkDate = moment(value).startOf('day');
                      if (invoiceDate && checkDate.isBefore(invoiceDate)) {
                        return `Date cannot be before invoice date (${invoiceDate.format("DD/MM/YYYY")})`;
                      }
                      if (checkDate.isAfter(today)) {
                        return "Future dates are not allowed";
                      }
                      return true;
                    }
                  }}
                  defaultValue={moment().format("YYYY-MM-DD")}
                  render={({ field }) => (
                    <DatePicker size="sm"
                      {...field}
                      format="dd/MM/yyyy"
                      oneTap
                      placeholder="dd/mm/yyyy"
                      style={{ width: "100%" }}
                      value={field.value ? new Date(field.value) : null}
                      onChange={(date) => {
                        field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                      }}
                      shouldDisableDate={(date) => {
                        const invoiceDate = invoiceDetail?.createdAt ? moment(invoiceDetail?.createdAt).startOf('day') : null;
                        const today = moment().startOf('day');
                        const checkDate = moment(date).startOf('day');
                        return (invoiceDate && checkDate.isBefore(invoiceDate)) || checkDate.isAfter(today);
                      }}
                      container={() => document.querySelector('.debit-note-modal .modal-content') || document.body}
                      cleanable={false}
                    />
                  )}
                />
                <ErrorMessage message={errors?.transactionDate?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label className="form-label">Site</label>
                <select
                  className="form-select fw-medium w-100"
                  name="siteId"
                  disabled
                  {...register("siteId", {
                    // required: "This field is required",
                  })}
                >
                  <option
                    value={invoiceDetail?.workorder?.siteId}
                    className=""
                  >
                    {invoiceDetail?.workorder?.site?.name}
                  </option>
                </select>
                <ErrorMessage message={errors?.siteId?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label className="form-label">Invoice Number</label>
                <select
                  className="form-select fw-medium w-100"
                  name="invoiceId"
                  disabled
                  {...register("invoiceId", {
                    // required: "This field is required",
                  })}
                >
                  <option value={invoiceDetail?.id} className="">
                    {invoiceDetail?.invoiceNumber}
                  </option>
                </select>
                <ErrorMessage message={errors?.invoiceId?.message} />
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                  <h4 className="fs-3 rajdhani-semibold my-4 ">
                    Payment Details
                  </h4>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <div className="form-group mb-3">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    step="any"
                    className="form-control"
                    name="amount"
                    {...register("amount", {
                      required: "Amount is required",
                    })}
                  />
                  <ErrorMessage message={errors?.amount?.message} />
                </div>
              </div>
              {/* <div className="col-12 col-md-6 col-lg-3">
                    <div className="form-group mb-3">
                      <label className="form-label">GST Rate</label>
                      <select
                        className="form-select form-control "
                        name="gst"
                        {...register("gst", {
                        required: "This field is required",
                      })}
                      >
                        <option value="" className="d-none">
                          GST
                        </option>
                        <option value={0}>0%</option>
                        <option value={5}>5%</option>
                        <option value={12}>12%</option>
                        <option value={18}>18%</option>
                        <option value={28}>28%</option>
                      </select>
                      <ErrorMessage message={errors?.gst?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3">
                    <div className="form-group mb-3">
                      <label className="form-label">Taxable Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        name="taxableAmount"
                        // disabled
                        // value={""}
                        {...register("taxableAmount", {
                          required: "This field is required",
                        })}
                      />
                      <ErrorMessage message={errors?.taxableAmount?.message} />
                    </div>
                  </div> */}
            </div>
            <div className="col-12 col-md-6 col-lg-8 w-100">
              <div className="form-group mb-2">
                <label className="form-label">Remark</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name="remark"
                  // defaultValue={""}
                  {...register("remark", {
                    required: "Remark is required",
                  })}
                />
                <ErrorMessage message={errors?.remark?.message} />
              </div>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeHandler}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={Balance === 0 || isLoading}
          >
            {isLoading ? <Spinner /> : editData ? "Update" : "Create"}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default CreateDebitNoteModal;
